import { render, staticRenderFns } from "./AdminChangeOwner.vue?vue&type=template&id=1441b011&scoped=true&"
import script from "./AdminChangeOwner.vue?vue&type=script&lang=js&"
export * from "./AdminChangeOwner.vue?vue&type=script&lang=js&"
import style0 from "./AdminChangeOwner.vue?vue&type=style&index=0&id=1441b011&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1441b011",
  null
  
)

export default component.exports